import { render } from "./index.vue?vue&type=template&id=6874148c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6874148c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6874148c"

export default script